export default __webpack_public_path__ + "static/media/labor-gray-icon.1479bfe7.svg";